const fantasyPositionsArray = [
    {
        index: 0,
        left: "555px",
        top: "300px",
    },
    {
        index: 1,
        left: "360px",
        top: "370px",
    },
    {
        index: 2,
        left: "745px",
        top: "350px",
    },
    {
        index: 3,
        left: "555px",
        top: "535px",
    },
    {
        index: 4,
        left: "815px",
        top: "560px",
    },
    {
        index: 5,
        left: "435px",
        top: "730px",
    },
    {
        index: 6,
        left: "830px",
        top: "755px",
    },
    {
        index: 7,
        left: "633px",
        top: "835px",
    },
    {
        index: 8,
        left: "75px",
        top: "910px",
    },
    {
        index: 9,
        left: "370px",
        top: "1085px",
    },
    {
        index: 10,
        left: "45px",
        top: "1207px",
    },
    {
        index: 11,
        left: "630px",
        top: "1230px",
    },
];

const mechPositionsArray = [
    {
        index: 0,
        left: "338px",
        top: "394px",
    },
    {
        index: 1,
        left: "616px",
        top: "479px",
    },
    {
        index: 2,
        left: "103px",
        top: "561px",
    },
    {
        index: 3,
        left: "394px",
        top: "690px",
    },
    {
        index: 4,
        left: "830px",
        top: "675px",
    },
    {
        index: 5,
        left: "612px",
        top: "892px",
    },
    {
        index: 6,
        left: "96px",
        top: "859px",
    },
    {
        index: 7,
        left: "405px",
        top: "1212px",
    },
    {
        index: 8,
        left: "125px",
        top: "1207px",
    },
    {
        index: 9,
        left: "725px",
        top: "1201px",
    },
    {
        index: 10,
        left: "631px",
        top: "187px",
    },
    {
        index: 11,
        left: "879px",
        top: "391px",
    },
];

const voidPositionsArray = [
    {
        index: 0,
        left: "400px",
        top: "175px",
    },
    {
        index: 1,
        left: "750px",
        top: "175px",
    },
    {
        index: 2,
        left: "200px",
        top: "450px",
    },
    {
        index: 3,
        left: "550px",
        top: "450px",
    },
    {
        index: 4,
        left: "750px",
        top: "750px",
    },
    {
        index: 5,
        left: "400px",
        top: "750px",
    },
    {
        index: 6,
        left: "200px",
        top: "1000px",
    },
    {
        index: 7,
        left: "550px",
        top: "1000px",
    },
    {
        index: 8,
        left: "750px",
        top: "1250px",
    },
    {
        index: 9,
        left: "400px",
        top: "1250px",
    },
    {
        index: 10,
        left: "200px",
        top: "1500px",
    },
    {
        index: 11,
        left: "550px",
        top: "1500px",
    },
];

export default function getPositionsArray(currentTheme) {
    let positionsArray;

    switch(currentTheme) {
        case "mech":
            positionsArray = mechPositionsArray;
            break;

        case "spring":
        case "summer":
        case "autumn":
        case "winter":
            positionsArray = fantasyPositionsArray;
            break;

        case "dvoid":
        case "lvoid":
            positionsArray = voidPositionsArray;
            break;

        default:
            positionsArray = fantasyPositionsArray;
            break;
    }

    return positionsArray;
}
